module.exports = __webpack_public_path__ + "img/56.af62ba81.jpg";